import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import Typography from '@/common/components/base/typography/Typography';
import { walletBalanceQueryOptions } from '@/modules/Dashboard/queries/walletBalance/walletBalanceQueryOptions.ts';
import { useQuery } from '@tanstack/react-query';
import { toJalaali } from 'jalaali-js';
import { useNavigate } from 'react-router-dom';
import { Box, Center, Flex } from 'styled-system/jsx';
import ArrowLeftIcon from '../../assets/icons/walletArrowLeft.svg?react';
import HeaderBackground from '../../assets/icons/walletHeaderBackground.svg?react';
import RialAmount from '../cashComponent/RialAmount';

export default function YearlyCard() {
  const navigate = useNavigate();
  const { data, isPending, isError } = useQuery(walletBalanceQueryOptions);
  const date = data?.lastDeposit ? new Date(data.lastDeposit) : null;
  const { jy, jm, jd } = date
    ? toJalaali(date.getFullYear(), date.getMonth() + 1, date.getDate())
    : { jy: 0, jm: 0, jd: 0 };

  if (isError) return <>error</>;

  if (isPending) {
    return (
      <Center flexDirection={'column'} gap={16} width={'100%'}>
        <CircularLoading color="colors.purple-primary" />
      </Center>
    );
  }

  return (
    <Box
      background={'linear-gradient(107deg, #7548F0 13.872%, #43298A 87.202%)'}
      boxShadow={'cardShadow'}
      position="relative"
      height={170}
      padding="16px"
      overflow={'hidden'}
    >
      <Box
        position="absolute"
        left={-34}
        top={-28}
        width={232}
        height={214}
        overflow={'hidden'}
        pointerEvents={'none'}
      >
        <Box
          position="absolute"
          left={-120}
          top={-71}
          opacity={0.5}
          transform={'scaleX(-1) rotate(10.23deg)'}
        >
          <HeaderBackground />
        </Box>
      </Box>
      <Flex flexDirection={'column'} gap={16} position={'relative'}>
        <Flex justifyContent={'space-between'} alignItems={'end'}>
          <Flex flexDirection={'column'} gap={8}>
            <Flex
              alignItems={'center'}
              gap={4}
              cursor={'pointer'}
              color={'white'}
              css={{ '& svg path': { fill: 'currentColor' } }}
              onClick={() => navigate(-1)}
            >
              <Box transform={'rotate(180deg)'}>
                <ArrowLeftIcon />
              </Box>
              <Typography fontSize={12} lineHeight={'24px'} color={'white'}>
                بازگشت
              </Typography>
            </Flex>
            <Typography textStyle={'h1'} color={'white'}>
              اعتبار کیف پول
            </Typography>
          </Flex>
          <RialAmount
            amount={data?.totalBalance || '0'}
            color={'white'}
            iconBoxSize={24}
            gap={0}
            textProps={{ fontSize: 20, fontWeight: 'bold' }}
          />
        </Flex>
        <Flex alignItems={'center'} gap={8}>
          <Typography color="white">آخرین واریزی:</Typography>
          <Typography color="white">
            {!jy || !jm
              ? '--'
              : `${jy}/${String(jm).padStart(2, '0')}/${String(jd).padStart(2, '0')}`}
          </Typography>
        </Flex>
      </Flex>
    </Box>
  );
}
